export const tasksTableDisplay = ['assignee', 'due_on']
export const tasksTableFilter = ['completed']
export const tasksTableSearchOptions = ['tasks', 'assignee']